module.exports = __webpack_public_path__ + "img/project-files.36e7f7e9.png";